import axios from "./jfetch"
import { api } from '../config/configUrl'
// let statisToken = localStorage.getItem(process.env.VUE_APP_PREFIX + 'statisToken');


const apis = {
  /**
   * @description 获取助力列表
   * @param {Object} param 
   * @returns 
   */
  list: param => axios.post(api.help.list, Object.assign(param,{platformType:'Platform_B2C'}))
}

export default apis